import React, { useState, useEffect } from 'react';
import api from '../api';

const cores = { navy: '#1A2233', navyD: '#253047', navyL: 'rgba(26,34,51,0.08)', gold: '#e8a020', green: '#27ae60', red: '#e74c3c', border: '#d4dde8', muted: '#6b7a8d', bg: '#f5f7fa', orange: '#D85A30' };

const iconeMap = {
  bus:   '🚌',
  car:   '🚗',
  moto:  '🏍️',
  food:  '🍽️',
  box:   '📦',
  other: '📎',
  park:  '🅿️',
  plane: '✈️',
  hotel: '🏨',
  fuel:  '⛽',
};

function getIcone(icone) {
  // Se já for emoji, retorna direto; senão mapeia
  if (!icone) return '📎';
  if ([...icone].length <= 2 && icone.match(/\p{Emoji}/u)) return icone;
  return iconeMap[icone] || '📎';
}

function StatusBadge({ status }) {
  const map = {
    pendente: { bg: '#fff3cd', color: '#856404', label: 'Pendente' },
    pago:     { bg: '#d1f5e0', color: '#155724', label: 'Pago' },
    reprovado:{ bg: '#fde8e8', color: '#991b1b', label: 'Reprovado' },
  };
  const s = map[status] || map.pendente;
  return (
    <span style={{ background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
      ● {s.label}
    </span>
  );
}

export default function Funcionario({ usuario, toast }) {
  const [subAba, setSubAba] = useState('lancar');
  const [catSel, setCatSel] = useState(null); // objeto categoria completo
  const [data, setData] = useState(new Date().toISOString().split('T')[0]);
  const [valor, setValor] = useState('');
  const [km, setKm] = useState('');
  const [desc, setDesc] = useState('');
  const [configs, setConfigs] = useState({ km_carro: 0.65, km_moto: 0.35 });
  const [lancamentos, setLancamentos] = useState([]);
  const [categorias, setCategorias] = useState([]); // ← agora é estado

  // Filtros de Meus Gastos
  const hoje = new Date();
  const [filtroTipo, setFiltroTipo] = useState('mensal'); // 'quinzena' | 'mensal' | 'anual'
  const [filtroMes, setFiltroMes] = useState(hoje.getMonth() + 1);
  const [filtroAno, setFiltroAno] = useState(hoje.getFullYear());
  const [filtroQuinzena, setFiltroQuinzena] = useState(hoje.getDate() >= 6 && hoje.getDate() <= 20 ? 1 : 2);

  useEffect(() => {
    api.get('/configuracoes').then(r => {
      const c = {};
      r.data.forEach(x => { c[x.chave] = parseFloat(x.valor); });
      setConfigs(c);
    }).catch(() => {});

    // Buscar categorias dinâmicas
    api.get('/configuracoes/categorias').then(r => {
      setCategorias(r.data);
    }).catch(() => {});

    carregarLancamentos();
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (subAba === 'meus') carregarLancamentos();
  // eslint-disable-next-line
  }, [subAba]);

  const carregarLancamentos = async () => {
    try {
      const r = await api.get(`/lancamentos?usuario_id=${usuario.id}`);
      setLancamentos(r.data);
    } catch {}
  };

  const isKm = catSel?.tipo === 'km';
  const kmRate = catSel?.nome?.toLowerCase().includes('moto') ? configs.km_moto : configs.km_carro;
  const kmTotal = (parseFloat(km) || 0) * kmRate;

  const salvar = async () => {
    if (!data) { toast('Informe a data', 'error'); return; }
    if (!catSel) { toast('Selecione uma categoria', 'error'); return; }
    if (isKm && !km) { toast('Informe os quilometros', 'error'); return; }
    if (!isKm && !valor) { toast('Informe o valor', 'error'); return; }
    try {
      await api.post('/lancamentos', {
        usuario_id: usuario.id,
        data, categoria: catSel.nome,
        descricao: desc,
        valor: isKm ? kmTotal : parseFloat(valor),
        km: isKm ? parseFloat(km) : null,
        quinzena: '1'
      });
      toast('Despesa lancada com sucesso!', 'success');
      setCatSel(null); setValor(''); setKm(''); setDesc('');
    } catch { toast('Erro ao salvar', 'error'); }
  };

  // Filtragem dos lançamentos
  const lancamentosFiltrados = lancamentos.filter(l => {
    const d = new Date(l.data.substring(0,10) + 'T00:00:00');
    const mes = d.getUTCMonth() + 1;
    const ano = d.getUTCFullYear();
    const dia = d.getUTCDate();
    if (filtroTipo === 'anual') return ano === filtroAno;
    if (filtroTipo === 'mensal') return mes === filtroMes && ano === filtroAno;
    if (filtroTipo === 'quinzena') {
      // 1ª quinzena: dias 6-20 do mês selecionado
      // 2ª quinzena: dias 21-31 do mês selecionado + dias 1-5 do mês seguinte
      if (filtroQuinzena === 1) {
        return ano === filtroAno && mes === filtroMes && dia >= 6 && dia <= 20;
      } else {
        // 2ª quinzena: dias 21-fim do mês selecionado + dias 1-5 do mês seguinte
        const mesSeguinte = filtroMes === 12 ? 1 : filtroMes + 1;
        const anoSeguinte = filtroMes === 12 ? filtroAno + 1 : filtroAno;
        const ehFinalMesAtual = ano === filtroAno && mes === filtroMes && dia >= 21;
        const ehInicioMesSeguinte = ano === anoSeguinte && mes === mesSeguinte && dia <= 5;
        return ehFinalMesAtual || ehInicioMesSeguinte;
      }
    }
    return true;
  });

  const total = lancamentosFiltrados.reduce((a, b) => a + parseFloat(b.valor), 0);
  const pend  = lancamentosFiltrados.filter(l => l.status === 'pendente').reduce((a, b) => a + parseFloat(b.valor), 0);
  const pago  = lancamentosFiltrados.filter(l => l.status === 'pago').reduce((a, b) => a + parseFloat(b.valor), 0);

  const meses = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
  const anos = Array.from({ length: 5 }, (_, i) => hoje.getFullYear() - 2 + i);

  const cardStyle = { background: 'white', borderRadius: 14, padding: 20, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' };
  const inputStyle = { padding: '10px 14px', border: `1.5px solid ${cores.border}`, borderRadius: 8, fontSize: 14, width: '100%', boxSizing: 'border-box' };
  const labelStyle = { fontSize: 12, fontWeight: 600, color: cores.muted, textTransform: 'uppercase', display: 'block', marginBottom: 6 };

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['lancar', '+ Lançar Despesa'], ['meus', 'Meus Gastos']].map(([key, label]) => (
          <button key={key} onClick={() => setSubAba(key)} style={{
            padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer',
            fontWeight: 600, fontSize: 13,
            background: subAba === key ? cores.orange : 'white',
            color: subAba === key ? 'white' : cores.muted,
            boxShadow: subAba === key ? '0 2px 8px rgba(232,114,12,0.3)' : '0 2px 8px rgba(0,0,0,0.06)',
          }}>
            {label}
          </button>
        ))}
      </div>

      {subAba === 'lancar' && (
        <div style={cardStyle}>
          <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 20 }}>📋 Lançar Despesa</div>

          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Data da despesa *</label>
            <input type="date" value={data} onChange={e => setData(e.target.value)} style={inputStyle} />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Categoria *</label>
            {categorias.length === 0 ? (
              <div style={{ color: cores.muted, fontSize: 13, padding: '12px 0' }}>
                Nenhuma categoria cadastrada. Acesse Configurações → Reembolso para adicionar.
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 }}>
                {categorias.map(c => (
                  <button key={c.id} onClick={() => setCatSel(c)} style={{
                    padding: '12px 6px',
                    border: `2px solid ${catSel?.id === c.id ? cores.orange : cores.border}`,
                    borderRadius: 12,
                    background: catSel?.id === c.id ? '#fff3eb' : 'white',
                    cursor: 'pointer', textAlign: 'center'
                  }}>
                    <div style={{ fontSize: 24 }}>{getIcone(c.icone)}</div>
                    <div style={{ fontSize: 11, fontWeight: 600, marginTop: 4, color: catSel?.id === c.id ? cores.orange : '#333' }}>{c.nome}</div>
                    {c.tipo === 'km' && <div style={{ fontSize: 9, color: cores.muted, marginTop: 2 }}>Por km</div>}
                  </button>
                ))}
              </div>
            )}
          </div>

          {isKm && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
              <div>
                <label style={labelStyle}>Quilometros *</label>
                <input type="number" value={km} onChange={e => setKm(e.target.value)} placeholder="0" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Total</label>
                <div style={{ fontSize: 20, fontWeight: 700, color: cores.orange, padding: '10px 0' }}>R$ {kmTotal.toFixed(2).replace('.', ',')}</div>
              </div>
            </div>
          )}

          {!isKm && catSel && (
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Valor (R$) *</label>
              <input type="number" value={valor} onChange={e => setValor(e.target.value)} placeholder="0,00" step="0.01" style={inputStyle} />
            </div>
          )}

          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Descricao</label>
            <textarea value={desc} onChange={e => setDesc(e.target.value)} rows={2} placeholder="Ex: Visita ao cliente..." style={{ ...inputStyle, resize: 'vertical' }} />
          </div>

          <button onClick={salvar} style={{ width: '100%', padding: 14, background: cores.orange, color: 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer' }}>
            Enviar Despesa
          </button>
        </div>
      )}

      {subAba === 'meus' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 16 }}>
            {[['Total', total, cores.navy], ['Aguardando', pend, cores.gold], ['Pago', pago, cores.green]].map(([label, val, cor]) => (
              <div key={label} style={{ ...cardStyle, padding: 14, borderLeft: `4px solid ${cor}` }}>
                <div style={{ fontSize: 11, color: cores.muted, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
                <div style={{ fontSize: 16, fontWeight: 700 }}>R$ {val.toFixed(2).replace('.', ',')}</div>
              </div>
            ))}
          </div>

          {/* ── Filtros ── */}
          <div style={{ ...cardStyle, marginBottom: 16, padding: '16px 20px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>

              {/* Tipo de filtro */}
              <div style={{ display: 'flex', gap: 6 }}>
                {[['quinzena','Quinzena'],['mensal','Mensal'],['anual','Anual']].map(([key, label]) => (
                  <button key={key} onClick={() => setFiltroTipo(key)} style={{
                    padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer',
                    fontWeight: 600, fontSize: 12,
                    background: filtroTipo === key ? cores.orange : '#f0f3f7',
                    color: filtroTipo === key ? 'white' : cores.muted,
                  }}>{label}</button>
                ))}
              </div>

              {/* Ano */}
              <select value={filtroAno} onChange={e => setFiltroAno(Number(e.target.value))}
                style={{ padding: '6px 10px', borderRadius: 8, border: `1.5px solid ${cores.border}`, fontSize: 13, cursor: 'pointer' }}>
                {anos.map(a => <option key={a} value={a}>{a}</option>)}
              </select>

              {/* Mês (oculto no anual) */}
              {filtroTipo !== 'anual' && (
                <select value={filtroMes} onChange={e => setFiltroMes(Number(e.target.value))}
                  style={{ padding: '6px 10px', borderRadius: 8, border: `1.5px solid ${cores.border}`, fontSize: 13, cursor: 'pointer' }}>
                  {meses.map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
                </select>
              )}

              {/* Quinzena (só no modo quinzena) */}
              {filtroTipo === 'quinzena' && (
                <div style={{ display: 'flex', gap: 6 }}>
                  {[[1,'1ª (6-20)'],[2,'2ª (21-5)']].map(([q, label]) => (
                    <button key={q} onClick={() => setFiltroQuinzena(q)} style={{
                      padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer',
                      fontWeight: 600, fontSize: 12,
                      background: filtroQuinzena === q ? cores.navy : '#f0f3f7',
                      color: filtroQuinzena === q ? 'white' : cores.muted,
                    }}>{label}</button>
                  ))}
                </div>
              )}

              {/* Label do período */}
              <div style={{ fontSize: 12, color: cores.muted, marginLeft: 'auto' }}>
                {filtroTipo === 'anual' && `Ano ${filtroAno}`}
                {filtroTipo === 'mensal' && `${meses[filtroMes-1]} ${filtroAno}`}
                {filtroTipo === 'quinzena' && (filtroQuinzena === 1 ? `1ª quinzena (6-20) de ${meses[filtroMes-1]} ${filtroAno}` : `2ª quinzena (21/${meses[filtroMes-1]} a 05/${meses[filtroMes % 12 === 0 ? 0 : filtroMes]})`  )}
                {' · '}<strong>{lancamentosFiltrados.length}</strong> lançamento(s)
              </div>
            </div>
          </div>

          <div style={cardStyle}>
            <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 16 }}>🧾 Meus Lancamentos</div>
            {lancamentosFiltrados.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 48, color: cores.muted }}>
                <div style={{ fontSize: 48 }}>📭</div>
                <p>Nenhum lançamento neste período</p>
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr>
                      {['Data', 'Categoria', 'Valor', 'Status'].map(h => (
                        <th key={h} style={{ padding: '8px 10px', textAlign: 'left', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: cores.muted, borderBottom: `2px solid ${cores.border}`, whiteSpace: 'nowrap' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {lancamentosFiltrados.map(l => (
                      <tr key={l.id} style={{ borderBottom: `1px solid ${cores.border}` }}>
                        <td style={{ padding: '10px', whiteSpace: 'nowrap' }}>{new Date(l.data.substring(0,10) + 'T00:00:00').toLocaleDateString('pt-BR')}</td>
                        <td style={{ padding: '10px' }}>{l.categoria}</td>
                        <td style={{ padding: '10px', fontWeight: 500, whiteSpace: 'nowrap' }}>R$ {parseFloat(l.valor).toFixed(2).replace('.', ',')}</td>
                        <td style={{ padding: '10px' }}><StatusBadge status={l.status} /></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}